import { render } from "./QGroupModal.vue?vue&type=template&id=57d8ef8d"
import script from "./QGroupModal.vue?vue&type=script&lang=js"
export * from "./QGroupModal.vue?vue&type=script&lang=js"

import "./QGroupModal.vue?vue&type=style&index=0&id=57d8ef8d&lang=css"
script.render = render

export default script